import { AlertTriangle } from 'lucide-react';

import { mascaraPlaca } from '@/nucleo/formato/documentos';
import { cn } from '@/nucleo/utilitarios';
import { Badge } from '@/ui/base/badge';

/**
 * Como um veiculo se identifica na tela: CRM em cima, placa embaixo.
 *
 * A HIERARQUIA E DELIBERADA. O CRM e a licenca municipal — o documento do TEG, que aparece
 * no termo, na ordem de servico e na medicao. A placa e do Detran: muda quando o veiculo e
 * substituido e serve para conferir na rua. Quem trabalha com o programa procura pelo CRM;
 * quem esta no ponto de embarque le a placa. Os dois aparecem, e o primeiro em destaque.
 *
 * VEICULO SEM CRM NAO GANHA CELULA VAZIA, GANHA AVISO. Placa sem licenca municipal e um
 * veiculo que ainda nao pode rodar no programa — e uma pendencia, nao um campo em branco, e
 * a diferenca decide se alguem vai atras dela.
 *
 * `tabular-nums` no CRM porque uma coluna de numeros que nao alinha obriga a ler digito por
 * digito para comparar duas linhas.
 */

interface VeiculoChaveVisualProps {
  crm: string | null | undefined;
  placa: string;
  tamanho?: 'sm' | 'md' | 'lg';
  /** `stack` empilha (padrao, para tabela); `row` alinha na mesma linha. */
  arranjo?: 'stack' | 'row';
  className?: string;
}

const TAMANHOS = {
  sm: { crm: 'text-xs', placa: 'text-[10px]' },
  md: { crm: 'text-sm', placa: 'text-xs' },
  lg: { crm: 'text-base', placa: 'text-xs' },
} as const;

export function VeiculoChaveVisual({
  crm,
  placa,
  tamanho = 'md',
  arranjo = 'stack',
  className,
}: VeiculoChaveVisualProps) {
  const escala = TAMANHOS[tamanho];
  const placaFormatada = mascaraPlaca(placa);
  const disposicao = arranjo === 'row' ? 'flex items-baseline gap-2' : 'flex flex-col gap-0.5';

  if (!crm) {
    return (
      <div className={cn(disposicao, className)}>
        <span className={cn('font-mono font-semibold', escala.crm)}>{placaFormatada}</span>
        <Badge variant="outline" className="border-warning/40 text-warning-text gap-1 text-[10px]">
          <AlertTriangle className="h-3 w-3" aria-hidden="true" />
          CRM pendente
        </Badge>
      </div>
    );
  }

  return (
    <div className={cn(disposicao, className)}>
      <span className={cn('font-mono font-semibold tabular-nums', escala.crm)}>{crm}</span>
      <span className={cn('text-muted-foreground font-mono', escala.placa)}>{placaFormatada}</span>
    </div>
  );
}
